import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { makeGetMarket } from 'sportsbook-markets-selector';
import Event from './event';

const EventContainer = ({
  id,
  meeting_id: meetingId,
  fullDescription,
  event_markets_count: eventMarketsCount,
  market,
  getEventHref,
  metadata,
}) => (
  <Event
    id={id}
    meetingId={meetingId}
    fullDescription={fullDescription}
    eventMarketsCount={eventMarketsCount}
    market={market}
    eventHref={getEventHref({ meetingId, eventId: id })}
    metadata={metadata}
  />
);

EventContainer.propTypes = {
  id: PropTypes.number.isRequired,
  meeting_id: PropTypes.number.isRequired,
  fullDescription: PropTypes.string.isRequired,
  getEventHref: PropTypes.func.isRequired,
  event_markets_count: PropTypes.number.isRequired,
  market: PropTypes.instanceOf(Object).isRequired,
  metadata: PropTypes.instanceOf(Object).isRequired,
};

// TODO: This makeMapStateToProps is exactly the same as used by upcoming races
// Shared them in some place, same selectors folder, not sure yet
const makeMapStateToProps = () => {
  const getMarket = makeGetMarket();

  return (state, props) => ({
    // TODO: Change server name for attribute for camel case ???
    market: getMarket(state, { id: props.market_id }),
  });
};

export default connect(makeMapStateToProps)(EventContainer);
